import Input from "../input/Input.vue";
import DatePicker from "../input/DatePicker.vue";
import LicensePlateInput from "../input/LicensePlateInput.vue";
import FileInput from "../input/FileInput.vue";
import NumberInput from "../input/NumberInput.vue";
import Switch from "../input/Switch.vue";
import Textarea from "../input/Textarea.vue";
import Select from "../input/Select.vue";
import Percentage from "../input/PercentageInput.vue";
import Amount from "../input/AmountInput.vue";
import PostalCodeInput from "../input/PostalCodeInput.vue";

export default {
  Input,
  DatePicker,
  FileInput,
  NumberInput,
  Switch,
  Textarea,
  Select,
  Percentage,
  Amount,
  PostalCode: PostalCodeInput,
  LicensePlate: LicensePlateInput,
};
